import { Component, OnInit, Input, Inject, HostListener } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { setting } from '../../../../setting';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import * as moment from 'moment';
import { RestService } from '../rest.service';
moment.locale('es');

@Component({
  selector: 'usb-modals',
  templateUrl: './modals.component.html',
  styleUrls: ['./modals.component.scss']
})
export class ModalsComponent implements OnInit {

  public options = {
    position: ['top', 'right'],
    timeOut: 460,
    lastOnBottom: true,
    showProgressBar: false,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 60
  };

  @Input() productQty: number;
  @Input() modalRoomRef: BsModalRef;
  @Input() product: any;
  @Input() results: any;
  @Input() form: FormGroup;
  @Input() payloadUpdate?: any;
  @Input() payload?: any;
  @Input() itineraryItem?: any;
  @Input() origin: any;
  @Input() arrayResults?: any;
  @Input() _item?: any;
  @Input() view_info: any;
  @Input() tabActive?: any;
  @Input() arrivalDate?: any;
  @Input() departureDate?: any;
  @Input() fliyingInfo?: any;
  @Input() formTransport: any;
  @Input() quote: boolean = true;
  @Input() action: string = '';

  appLoading: boolean = false;
  closeModal: boolean = false;
  clientSetting: any;
  currencies: any[] = [];
  currencyAgency: any;
  paymentConditions: any;
  paymentAgencyActive: any;
  vehicles: any[] = [];

  openInfoDescription: boolean = false;
  _from: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalsComponent>,
    public spinner: NgxSpinnerService,
    private userService: UserService,
    private _restService: RestService
  ) { }

  ngOnInit() {
    this.currencies = this.userService.currenciesExchange;
    this.currencyAgency = this.userService.currency;
    this.clientSetting = JSON.parse(localStorage.getItem(setting.name));
    // console.log("modal product", this.data);
    this.paymentAgencyActive = this.data.paymentAgencyActive ? this.data.paymentAgencyActive : null;
    this.productQty = this.data.productQty ? this.data.productQty : null;
    //this.modalRoomRef = this.data.modalRoomRef;
    this.product = this.data.product ? this.data.product : null;
    this.results = this.data.results ? this.data.results : null;
    this.form = this.data.form ? this.data.form : null;
    this.payloadUpdate = this.data.payloadUpdate ? this.data.payloadUpdate : null;
    this.payload = this.data.payload ? this.data.payload : null;
    this.itineraryItem = this.data.itineraryItem ? this.data.itineraryItem : null;
    this.origin = this.data.origin ? this.data.origin : null;
    this.arrayResults = this.data.arrayResults ? this.data.arrayResults : null;
    this._item = this.data._item ? this.data._item : null;
    this.view_info = this.data.view_info ?  this.data.view_info : null;

    this.tabActive = this.data.tabActive ?  this.data.tabActive : null;
    this.departureDate = this.data.departureDate ?  this.data.departureDate : null;
    this.fliyingInfo = this.data.flyingInfo ? this.data.flyingInfo : null;
    this.formTransport = this.data.formTransport ? this.data.formTransport : null;
    this.arrivalDate = this.data.arrivalDate ? this.data.arrivalDate : null;
    this.vehicles = this.data.vehicles ? this.data.vehicles : null;
    this.quote = this.data.quote;
    this.action = this.data.action;
    this.openInfoDescription = this.data?.openInfoDescription;
    this._from = this.data?.from || '';
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    if (!target?.classList?.contains('cdk-overlay-backdrop')) {
      return;
    }

    // Si hay un mat-select-panel abierto, el click sobre el backdrop es para
    // cerrar el select, no el modal. El panel del select está dentro del
    // cdk-overlay-container y su backdrop propio se monta encima del nuestro.
    if (document.querySelector('.mat-select-panel')) {
      console.debug('[modals] backdrop click ignorado: hay un mat-select-panel abierto');
      return;
    }

    console.debug('[modals] backdrop click → cerrando modal');
    this.dialogRef.close('close');
  }

  hideModal(status: string) {
    this.appLoading = true;
    // console.log("status", status);

    const stat = status.split(' - ');
    const type = stat[0];
    const title = stat[1];
    const message = stat[2];

    switch (type) {
      case 'success': this.options.timeOut = 360;
        break;
      case 'error': this.options.timeOut = 1060; 
        break;
      case 'warning':
        break;
    }

    if(status == 'close'){
      this.dialogRef.close(status);
      // this.closeModal = true;
      this.appLoading = false;
    }else{
      this.dialogRef.close(status);
      // this.closeModal = true;
      this.appLoading = false;
    }

  }



}
